import { IExperiment } from './IExperimentManager';

/**
 * Whether an experiment is an actively-running split — the only case where
 * logging an exposure is meaningful. Returns false for single-bucket experiments:
 * `rollout: 0` (no one is enrolled) or any variant at `weight: 100` (everyone gets
 * the same variant). Those have no control/treatment comparison, so their exposure
 * events are noise.
 */
export function isActiveSplit(experiment: Pick<IExperiment, 'rollout' | 'variants'>): boolean {
  if (experiment.rollout === 0) {
    return false;
  }
  return !experiment.variants.some((variant) => variant.weight === 100);
}
